import { render, staticRenderFns } from "./indexFut.vue?vue&type=template&id=0033f20a&scoped=true"
import script from "./indexFut.vue?vue&type=script&lang=js"
export * from "./indexFut.vue?vue&type=script&lang=js"
import style0 from "./indexFut.vue?vue&type=style&index=0&id=0033f20a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0033f20a",
  null
  
)

export default component.exports